import { render, staticRenderFns } from "./WorkFileTracking.vue?vue&type=template&id=817c9a0a"
import script from "./WorkFileTracking.vue?vue&type=script&lang=ts"
export * from "./WorkFileTracking.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports